<template>
  <component :is="orderData === undefined ? 'div' : 'b-card'">
    <!-- Alert: No item found -->

    <b-alert variant="danger" :show="orderData === undefined">
      <h4 class="alert-heading">取得入貨單資料時出錯</h4>
      <div class="alert-body">
        找不到具有該使用者 ID 的使用者。查看
        <b-link class="alert-link" :to="{ name: 'orders-list' }">
          入貨單列表
        </b-link>
      </div>
    </b-alert>

    <b-tabs v-if="orderData" pills>
      <!-- Tab: Information -->
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
          <span class="d-none d-sm-inline">入貨單資料</span>
        </template>
        <order-edit-tab-information
          :order-data="orderData"
          :supplier-options="supplierOptions"
          @refetch-data="refetchData"
          class="mt-2 pt-75"
        />
      </b-tab>
    </b-tabs>
  </component>
</template>

<script>
import { BTab, BTabs, BCard, BAlert, BLink } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import orderStoreModule from "../orderStoreModule";
import OrderEditTabInformation from "./OrderEditTabInformation.vue";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    OrderEditTabInformation,
  },
  setup() {
    const orderData = ref(null);

    const USER_APP_STORE_MODULE_NAME = "app-order";

    const itemFormBlankItem = {
      product_id: null,
      description: "",
      unit_price: 0,
      quantity: 1,
    };

    const order = {
      id: 0,
      supplier_id: null,
      order_date: null,
      remark: "",
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],
    };

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, orderStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    onMounted(() => {
      refetchOptions();
    });

    const refetchData = () => {
      if (router.currentRoute.name == "purchase-orders-create") {
        orderData.value = order;
      } else {
        store
          .dispatch("app-order/fetchOrder", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            orderData.value = response.data.order;
            orderData.value.is_active =
              orderData.value.is_active == 1 ? true : false;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              orderData.value = undefined;
            }
          });
      }
    };

    refetchData();

    const supplierOptions = ref([]);
    const refetchOptions = () => {
      store
        .dispatch("app/fetchOptionList", { supplier: true })
        .then((response) => {
          supplierOptions.value = response.data.suppliers;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    return {
      orderData,
      refetchData,
      supplierOptions,
    };
  },
};
</script>

<style></style>
